import { CHANGE_STATES } from "features/Common/modules/Form/constants/Form.constants";
import {
  CHANNEL_API_KEYS,
  CUSTOM_LINK_API_KEYS,
} from "../constants/MembershipsSection.data";

export const hasMembershipUuidDiff = ({
  initialUuids = [],
  selectedUuids = [],
}) => {
  const initialSet = new Set(initialUuids || []);
  const selectedSet = new Set(selectedUuids || []);

  if (initialSet.size !== selectedSet.size) return true;

  for (const uuid of initialSet) {
    if (!selectedSet.has(uuid)) return true;
  }

  return false;
};

const getMembershipTitle = ({ membershipList, uuid }) =>
  membershipList?.list?.find((membership) => membership.uuid === uuid)?.title ||
  uuid;

export const getMembershipUuidDiffLabels = ({
  initialUuids = [],
  selectedUuids = [],
  membershipList,
}) => {
  const initialSet = new Set(initialUuids || []);
  const selectedSet = new Set(selectedUuids || []);
  const labels = [];

  for (const uuid of selectedUuids || []) {
    if (!initialSet.has(uuid)) {
      labels.push(
        `Added membership: ${getMembershipTitle({ membershipList, uuid })}`
      );
    }
  }

  for (const uuid of initialUuids || []) {
    if (!selectedSet.has(uuid)) {
      labels.push(
        `Removed membership: ${getMembershipTitle({ membershipList, uuid })}`
      );
    }
  }

  return labels;
};

export const getChannelMappingChangeLabels = ({
  editedChannels = [],
  channelNameById = {},
}) =>
  editedChannels.map((channel) => {
    const channelUuid = channel[CHANNEL_API_KEYS.CHANNEL_ID];
    const channelName =
      channelNameById[channelUuid] ||
      channel.title ||
      channel[CHANNEL_API_KEYS.CHANNEL_NAME] ||
      channelUuid;
    const action =
      channel.change_type === CHANGE_STATES.added
        ? "Added channel"
        : "Removed channel";

    return `${action}: ${channelName}`;
  });

export const getLinkMappingChangeLabels = ({
  editedLinks = [],
  linkNameById = {},
}) =>
  editedLinks.map((link) => {
    const linkUuid = link[CUSTOM_LINK_API_KEYS.LINK_UUID];
    const linkName = linkNameById[linkUuid] || link.title || linkUuid;
    const action =
      link.change_type === CHANGE_STATES.added ? "Added link" : "Removed link";

    return `${action}: ${linkName}`;
  });
